import styled from "styled-components";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as SidebarWrapperStyles from "../../../../../../../common-deprecated/components/styles/SidebarWrapperStyles";
import * as FilterList from "./FilterListStyles";
import * as CarTypeFilter from "../car-type/styles/CarTypeFilterStyles";

export const SidebarContainer = styled.div<{ absolute: boolean }>`
    position: ${(props) => (props.absolute ? "absolute" : "relative")};
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    background-color: ${theme.colors.steel};
    z-index: ${theme.zIndex.fixed - 1}; /* Minus one so it renders under the static filter bar */

    ${FilterList.Header} {
        margin: 0 -${theme.spacer / 2}px;
        padding: ${theme.space[2]}px ${theme.space[3]}px;
        border-bottom: 1px solid ${theme.colors.brushedSteel};
        @media ${getBreakpoint("up", "lg")} {
            margin: 0;
            padding: ${theme.space[2]}px 0;
            border-bottom: 1px solid transparent;
        }
    }

    ${CarTypeFilter.SearchTextButton} {
        @media ${getBreakpoint("up", "lg")} {
            background-color: ${theme.colors.steel};
        }
    }

    ${SidebarWrapperStyles.Wrapper} {
        @media ${getBreakpoint("up", "xs")} {
            width: 100%;
        }
    }

    @media ${getBreakpoint("down", "md")} {
        position: relative;
        left: 0;
    }

    @media ${getBreakpoint("down", "lg")} {
        width: 100vw;
    }

    html[dir="rtl"] & {
        left: auto;
        right: 0;
        @media ${getBreakpoint("down", "md")} {
            left: auto;
            right: 0;
        }
    }
`;

// Mobile header should stay fixed while content below should be scrollable
const headerHeight = 60;
export const MobileHeader = styled.div`
    display: none;

    @media ${getBreakpoint("down", "lg")} {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: ${headerHeight}px;
        background: ${theme.colors.black};
        z-index: ${theme.zIndex.materialbox};
    }

    html[dir="rtl"] & {
        @media ${getBreakpoint("down", "lg")} {
            left: auto;
            right: 0;
        }
    }
`;

export const Wrapper = styled.div<{
    show: boolean;
    disableTransition: boolean;
    reachOutMobile?: number;
}>`
    position: relative;
    flex: unset;
    align-self: stretch;
    transition: ${(props) => (props.disableTransition ? "none" : "padding 0.3s, width 0.3s")};

    @media ${getBreakpoint("down", "lg")} {
        display: ${(props) => (props.show ? "block" : "none")};
        position: fixed;
        top: ${headerHeight}px;
        left: 0;
        right: 0;
        width: 100vw;
        height: ${({ reachOutMobile }) =>
            reachOutMobile ? `calc(100% - ${headerHeight}px - ${reachOutMobile}px)` : `calc(100% - ${headerHeight}px)`};
        padding: 0;
        background: ${theme.colors.white};
        transition: none;
        overflow-x: hidden;
        overflow-y: scroll;
        z-index: ${theme.zIndex.materialbox};
    }
`;
